//@flow
import React from 'react';
import {percentOfTotalNotFixed} from '../../../helpers';
import s from './TopLineScale.less';
import getProperty from 'lodash.get';

type Props = {
  totalFobTooling: number,
  data: Object,
};

const TopLineScale = ({totalFobTooling, data}: Props) => {
  const sectionToolingCost = getProperty (
    data,
    ['Tooling Cost', 'sectionSummary', 'cost'],
    0
  );
  const otherAdjCost = getProperty (
    data,
    ['Other Cost', 'sectionSummary', 'cost'],
    0
  );

  const FobWithoutTooling = totalFobTooling - sectionToolingCost;

  //The FOB topline section needs to end at the beginning of the Other Adjustment cost bar if it is negative.
  //This gets the correct width percentage for the topline scale.
  const scaleWidth = otherAdjCost >= 0
    ? percentOfTotalNotFixed (
        sectionToolingCost + FobWithoutTooling,
        FobWithoutTooling
      )
    : percentOfTotalNotFixed (
        sectionToolingCost + FobWithoutTooling,
        FobWithoutTooling + otherAdjCost
      );

  return (
    <div className={`${s.topLineScaleWrapper}`}>
      <div className={`${s.textContainer}`}>
        <div
          style={{
            width: scaleWidth,
            marginBottom: '0.5em',
          }}
        >
          <p className={`${s.withToolingText}`}>
              FOB Cost
          </p>
        </div>
        <div
          style={{
            width: percentOfTotalNotFixed (
              FobWithoutTooling + sectionToolingCost,
              sectionToolingCost
            ),
            marginBottom: '0.5em',
          }}
        >
          {sectionToolingCost
            ? <p className={`${s.toolingText}`}>
                Tooling
              </p>
            : null}
        </div>
      </div>
      <div className={`${s.lineContainer}`}>
        <div
          style={{
            width: scaleWidth,
          }}
          className={`${s.fobLine}`}
        />
        {sectionToolingCost
          ? <div
              style={{
                width: percentOfTotalNotFixed (
                  FobWithoutTooling + sectionToolingCost,
                  sectionToolingCost
                ),
              }}
              className={`${s.toolingLine}`}
            />
          : null}
      </div>
    </div>
  );
};

export default TopLineScale;



// WEBPACK FOOTER //
// ./src/components/StackedBarChart/TopLineScale/TopLineScale.js